<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4ARYkd/images/9781439647929.jpg?1684305909611" alt="This image is the cover for the book Randolph Field, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Randolph Field, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Once touted as the �West Point of the air� in the pre�Air Force Academy years, Randolph Field/Air Force Base is famous for its Spanish Colonial Revival architecture, its iconic Administration Building (nicknamed the �Taj Mahal�), and its rectangular layout. Allowed by the Army hierarchy to design its own installation from the ground up, the Army Air Corps hit a home run in design uniqueness and functionality. When the Corps of Engineers built the base, working from 1928 to 1931, it was its biggest project since the Panama Canal. Randolph has been a popular assignment location for Air Force members for over 80 years and is currently home to the 12th Flying Training Wing, the Air Education and Training Command Headquarters, and the Air Force Personnel Center. Thousands have passed through Randolph�s gates as students and permanent personnel, and many have chosen to live in the San Antonio area after discharge or retirement. Carefully landscaped with trees and shrubbery from the very beginning, Randolph is the �showplace of the Air Force.�</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lt. Col. Michael P. Hoffman (USAF Retired)
      </h2>
      
      <p class="authorDescription body article">Author Michael P. Hoffman is a retired Air Force lieutenant colonel. As an Air Force officer, he was assigned to the base twice for a total of seven years. He retired in 1991 and returned to live in Universal City, Texas, right outside the front gate of Randolph. He has been a student of Randolph history since 1970, hence his interest in publishing this book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?728f6f69